import React from 'react';

import { QueryClient } from '@tanstack/react-query';

import { UploadManagement } from 'pages/uploads';

import { useProviderUploadManagementData } from './useProviderUploadManagementData';

interface ProviderUploadManagementProps {
  queryClient: QueryClient;
}

export const ProviderUploadManagement: React.FC<
  ProviderUploadManagementProps
> = ({ queryClient }) => {
  const {
    items,
    total,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    pagination,
    setPagination,
    statusGroupCounts,
    sites,
  } = useProviderUploadManagementData(queryClient);

  return (
    <UploadManagement
      items={items}
      total={total}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
      pagination={pagination}
      setPagination={setPagination}
      statusGroupCounts={statusGroupCounts}
      sites={sites}
    />
  );
};
